import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false,
};

const info = async (store, id, meta = {}) => {
  store.setState((state) => {
    state.modulo.recepcion.info.busy = true;
  });

  const params = {
    ...meta,
    include: 'field',
  };

  try {
    const response = await Http.get(`api/recepciones/${id}`, { params });

    store.setState((state) => {
      state.modulo.recepcion.info.data = response.data;
      state.modulo.recepcion.info.busy = false;
    });

    return response.data;
  } catch (error) {
    store.setState((state) => {
      state.modulo.recepcion.info.error = error.data || error;
      state.modulo.recepcion.info.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.modulo.recepcion.info.error = undefined;
};

const reset = (store) => (state) => {
  state.modulo.recepcion.info = { ...initialState };
};

const actions = {
  info,
  reset,
  resetError,
};

const RecepcionInfoStore = {
  state: () => initialState,
  actions,
};

export default RecepcionInfoStore;
